interface TableTitleProps {
  title: string;
  align?: "center" | "left" | "right" | "justify" | "char" | undefined;
  width?: number;
}

interface TableStdProps {
  titles: TableTitleProps[];
  noBorder?: boolean;
  fixedLayout?: boolean;
  children: React.ReactNode;
}

const TableStd = ({ titles, noBorder, fixedLayout, children }: TableStdProps) => {
  return (
    <>
      <div
        className={`${noBorder ? `border-none` : `border-2 border-[#666] border-t-none`}`}
      >
        <table
          width="100%"
          cellSpacing={0}
          className="border-t border-t-[#CCC] text-[#666]"
          style={fixedLayout ? { tableLayout: 'fixed' } : undefined}
        >
          <tbody>
            <tr>
              {titles.map((title: TableTitleProps, idx) => (
                <th
                  align={title.align}
                  className="text-[#666] font-bold border-b border-b-[#999] px-3 py-1 bg-[#D8D8D8]"
                  style={title.width ? { width: `${title.width}px` } : undefined}
                  key={idx}
                >
                  {title.title}
                </th>
              ))}
            </tr>
            {children}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default TableStd;
